<template>
  <div>
    <div class="M_H topBtn">
      <el-button type="warning" size="mini" @click="saveData">提 交</el-button>
    </div>
    <div class="mainBox">
      <div class="newForm">
        <!-- 选项 () -->
        <!-- <div class="M_H radiosBox">
              <el-checkbox v-model="checked1" :label="1">直接转运</el-checkbox>
              <el-checkbox v-if="checked1" v-model="checked2" :label="2"
                >需要上门取件</el-checkbox
              >
            </div> -->
        <el-form
            ref="newForm"
            :model="newForm"
            :rules="newFormRules"
            label-width="100px"
        >
          <!-- 基础信息 -->
          <div class="M" style="margin-bottom: 10px">
            <div class="inlineDiv">
              <div class="queryItem1">
                <el-form-item label="运单号:" prop="waybillNumber">
                  <el-input
                      v-model="applyPackInfo.waybillNumber"
                      placeholder="自动生成/手工录入"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="queryItem1">
                <el-form-item label="快递单号:" prop="courierNumber">
                  <el-input
                      v-model="newForm.courierNumber"
                      placeholder="唛头号/入仓号/运单号"
                  ></el-input>
                </el-form-item>
                <el-button type="primary" size="mini" @click="fillbut"
                >自动生成</el-button
                >
              </div>
              <div class="queryItem1">
                <el-form-item label="快递公司:" prop="expressName">
                  <el-select
                      v-model="newForm.expressName"
                      filterable
                      clearable
                      placeholder="请输入关键字快捷搜索"
                  >
                    <el-option
                        v-for="(item, index) in expressList"
                        :label="item.expressName"
                        :value="item.expressName"
                        :key="index"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>

            <div class="inlineDiv">
              <div class="queryItem1">
                <el-form-item label="会员号:" prop="memberId">
                  <el-select
                      class="queryInput"
                      @change="huiayu"
                      v-model="newForm.memberId"
                      placeholder="请输入会员号快捷搜索"
                      clearable
                      filterable
                      remote
                      reserve-keyword
                      :remote-method="getMembers"
                      value-key="memberId"
                  >
                    <el-option
                        v-for="(item, index) in huiyuanList"
                        :label="item.memberId"
                        :value="item.memberId"
                        :key="index"
                    >
                      {{ item.memberId }} : ({{ item.nickname }})
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="queryItem1">
                <el-form-item label="会员名称:">
                  <el-select
                      class="queryInput"
                      @change="huiayuName"
                      v-model="newForm.nickname"
                      placeholder="请输入关键字快捷搜索"
                      clearable
                      filterable
                      remote
                      reserve-keyword
                      :remote-method="getMembersName"
                      value-key="memberId"
                  >
                    <el-option
                        v-for="(item, index) in huiyuanList"
                        :label="item.nickname"
                        :value="item.nickname"
                        :key="index"
                    >
                      {{ item.nickname }}
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="queryItem1">
                <el-form-item label="货物品类:" prop="itemCategoryCode">
                  <el-select
                      v-model="newForm.itemCategoryCode"
                      placeholder="请选择"
                      filterable
                      clearable
                  >
                    <el-option
                        v-for="(item, index) in qudaoList"
                        :label="item.showName"
                        :value="item.itemCategoryCode"
                        :key="index"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>

            <div class="inlineDiv">
              <div class="queryItem1">
                <el-form-item label="入仓仓库:" prop="storageId">
                  <el-select
                      filterable
                      clearable
                      v-model="newForm.storageId"
                      placeholder="请选择仓库"
                  >
                    <el-option
                        v-for="(item, index) in cangkuList"
                        :label="item.storageName"
                        :value="item.id"
                        :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="queryItem1">
                <el-form-item label="运输方式:" prop="transportId">
                  <el-select
                      v-model="applyPackInfo.transportId"
                      clearable
                      @change="selectTId"
                      placeholder="请选择运输方式"
                  >
                    <el-option
                        v-for="(item, index) in transportList"
                        :label="item.transportName"
                        :key="item.channelTransportId"
                        :value="item.channelTransportId"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="queryItem1">
                <el-form-item label="数据确认类型:" prop="isCustomerCheckScale">
                  <el-select
                      v-model="applyPackInfo.isCustomerCheckScale"
                      clearable
                      placeholder="请选择确认类型"
                  >
                    <el-option
                        v-for="(item, index) in isCustomerCheckScaleList"
                        :label="item.label"
                        :key="item.value"
                        :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="inlineDiv">
              <div class="queryItem1">
                <el-form-item label="付款方式:" prop="paymentMethodStatus">
                  <el-select
                      filterable
                      clearable
                      v-model="applyPackInfo.paymentMethodStatus"
                      placeholder="请选择"
                  >
                    <el-option
                        v-for="item in payType"
                        :label="item.showName"
                        :key="item.statusVal"
                        :value="item.statusVal"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="queryItem1">
                <el-form-item label="出货渠道:" prop="channelId">
                  <el-select
                      filterable
                      clearable
                      v-model="applyPackInfo.channelId"
                      placeholder="请选择"
                  >
                    <el-option
                        v-for="(item, index) in channelList"
                        :label="item.channelName"
                        :key="item.channelId"
                        :value="item.channelId"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="queryItem1">
                <el-form-item label="客户单号:" prop="customerNumber">
                  <el-input
                      v-model="applyPackInfo.customerNumber"
                      placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="inlineDiv">
              <div class="queryItem1">
                <el-form-item label="末端派送:" prop="handoverMode">
                  <el-select
                      filterable
                      clearable
                      v-model="applyPackInfo.handoverMode"
                      placeholder="请选择"
                  >
                    <el-option
                        v-for="item in handoverModeList"
                        :label="item.val"
                        :key="item.key"
                        :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="queryItem1">
                <el-form-item label="等通知放货:" prop="withholdStatus">
                  <el-select
                      v-model="applyPackInfo.withholdStatus"
                      clearable
                      placeholder="请选择"
                  >
                    <el-option
                        v-for="(item, index) in withholdStatusList"
                        :label="item.label"
                        :key="item.value"
                        :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="queryItem1">
                <el-form-item label="预计运费:" prop="estimatedFreight">
                  <el-input
                      v-model="applyPackInfo.estimatedFreight"
                      placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="inlineDiv">
              <div class="queryItem1" style="width: 94%">
                <el-form-item label="备注:" prop="comment">
                  <el-input
                      clearable
                      type="textarea"
                      rows="2"
                      v-model="applyPackInfo.comment"
                      placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="inlineDiv">
              <div class="queryItem1" style="width: 94%; padding: 8px 0">
                <el-form-item label="打包服务:">
                  <el-checkbox-group
                      v-model="checkList"
                      class="wtl_displayFlex2"
                  >
                    <div
                        class="wtl_displayFlex2 ItemServerBox"
                        v-for="(item, index) in serveArr"
                        :key="index"
                    >
                      <div>
                        <el-checkbox
                            :label="item.itemServiceId"
                            @change="changeCheckBoxItem($event, index)"
                        >
                          {{ item.title }}
                        </el-checkbox>
                      </div>

                      <!--                      <div class="wtl_displayFlex">-->
                      <!--                        &lt;!&ndash; <div style="width: 40px; font-size: 12px">数量:</div> &ndash;&gt;-->
                      <!--                        <el-input-->
                      <!--                            class="countInput"-->
                      <!--                            placeholder="数量"-->
                      <!--                            v-model="item.count"-->
                      <!--                        ></el-input>-->
                      <!--                      </div>-->
                    </div>
                  </el-checkbox-group>
                </el-form-item>
              </div>
            </div>
          </div>
        </el-form>

      </div>
      <!-- 品名 -->
      <div class="M">
        <div class="M_tabel">
          <div class="inlineDiv">货物信息: </div>
          <el-table
              border
              :data="newForm.itemReqs"
              size="small"
              style="width: 100%; margin-top: 10px;"
              @row-click="handleRowClick"
              :row-class-name="highlightRowClassName"
              :header-cell-style="{ background: '#f0f0f0' }"
          >
            <el-table-column
                fixed="left"
                align="center"
                label="序号"
                type="index"
                width="40"
            ></el-table-column>

            <el-table-column align="center" prop="boxNo" label="箱号" width="100">
              <template slot-scope="scope">
                <el-input
                    class="myInputs"
                    v-model="newForm.itemReqs[scope.$index].boxNo"
                    placeholder="请输入"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="shippingMarkNo" label="唛头" width="100">
              <template slot-scope="scope">
                <el-input
                    class="myInputs"
                    v-model="newForm.itemReqs[scope.$index].shippingMarkNo"
                    placeholder="请输入"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
                prop="itemName"
                label="品名"
                align="center"
                min-width="200px"
            >
              <template slot-scope="scope">
                <el-select
                    v-model="newForm.itemReqs[scope.$index].itemNameCode"
                    filterable
                    clearable
                    size="mini"
                    allow-create
                    placeholder="请选择或输入"
                    @change="changeItem($event, scope.$index)"
                >
                  <el-option
                      v-for="(item, index) in qudaoNameList"
                      :key="index"
                      :value="item.itemNameCode"
                      :label="item.showName"
                  >
                  </el-option>
                </el-select>
                <el-input
                    class="myInputs"
                    v-if="!newForm.itemReqs[scope.$index].itemNameCode"
                    v-model="newForm.itemReqs[scope.$index].itemName"
                    placeholder="自定义品名"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
                prop="unitPrice"
                min-width="100px"
                align="center"
                label="单价"
            >
              <template slot-scope="scope">
                <el-input
                    size="mini"
                    placeholder="请输入单价"
                    v-model="newForm.itemReqs[scope.$index].unitPrice"
                >
                </el-input>
              </template>
            </el-table-column>

            <el-table-column
                prop="quantity"
                min-width="100px"
                align="center"
                label="件数"
            >
              <template slot-scope="scope">
                <el-input
                    size="mini"
                    type="number"
                    placeholder="请输入件数"
                    v-model="newForm.itemReqs[scope.$index].quantity"
                >
                </el-input>
              </template>
            </el-table-column>
            <el-table-column
                prop="intoStorageCount"
                min-width="100px"
                align="center"
                label="入库件数"
            >
              <template slot-scope="scope">
                <el-input
                    size="mini"
                    type="number"
                    placeholder="请输入入库件数"
                    v-model="newForm.itemReqs[scope.$index].intoStorageCount"
                >
                </el-input>
              </template>
            </el-table-column>
            <el-table-column
                prop="weight"
                min-width="100px"
                align="center"
                label="重量(kg)"
            >
              <template slot-scope="scope">
                <el-input
                    size="mini"
                    type="number"
                    placeholder="请输入"
                    v-model="newForm.itemReqs[scope.$index].weight"
                >
                </el-input>
              </template>
            </el-table-column>
            <el-table-column
                prop="intoStorageWeight"
                min-width="100px"
                align="center"
                label="入库重量(kg)"
            >
              <template slot-scope="scope">
                <el-input
                    size="mini"
                    type="number"
                    placeholder="请输入入库重量"
                    v-model="newForm.itemReqs[scope.$index].intoStorageWeight"
                >
                </el-input>
              </template>
            </el-table-column>
            <el-table-column
                prop="volume"
                min-width="200px"
                align="center"
                label="体积(m³)"
            >
              <template slot-scope="scope">
                <div class="wtl_displayFlex">
                  <el-input
                      size="mini"
                      type="number"
                      clearable
                      placeholder="请输入"
                      v-model="newForm.itemReqs[scope.$index].volume"
                  >
                  </el-input>
                  <!-- <i style="margin-left: 10px" class="el-icon-menu"></i> -->
                  <div
                      class="totBtns"
                      @click="totleVolume(scope.$index, scope.row)"
                  >
                    计算
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="intoStorageVolume"
                min-width="130px"
                align="center"
                label="入库体积(m³)"
            >
              <template slot-scope="scope">
                <div class="wtl_displayFlex">
                  <el-input
                      size="mini"
                      type="number"
                      clearable
                      placeholder="请输入"
                      v-model="newForm.itemReqs[scope.$index].intoStorageVolume"
                  >
                  </el-input>
                  <!-- <i style="margin-left: 10px" class="el-icon-menu"></i> -->
                  <!--                  <div-->
                  <!--                      class="totBtns"-->
                  <!--                      @click="totleVolume(scope.$index, scope.row)"-->
                  <!--                  >-->
                  <!--                    计算-->
                  <!--                  </div>-->
                </div>
              </template>
            </el-table-column>
            <el-table-column
                align="center"
                prop="specs"
                label="规格汇总"
                width="180"
            >
              <template slot-scope="scope">
                <el-input
                    type="textarea"
                    autosize
                    v-model="scope.row.specs"
                    placeholder="请输入"
                >
                </el-input>
              </template>
            </el-table-column>

            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div v-if="scope.$index === 0">
                  <el-button @click="addbtn(scope.$index)" size="mini"
                  >新增</el-button
                  >
                </div>
                <div v-else>
                  <el-button @click="delbut(scope.$index)" size="mini"
                  >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 规格信息（由货物信息带动更新） -->
      <el-card
          shadow="never"
          class="M"
      >
        <el-form class="M_tabel">
          <el-row>
            <el-col :span="23" class="jy-card-details">
              <div class="button-ground" >
                <el-button
                    size="large"
                    plain
                    class="jy-button"
                    @click="onInputSpecifications(1)"
                >规格替换填充↓</el-button
                >
                <el-button
                    size="large"
                    plain
                    class="jy-button"
                    @click="onInputSpecifications(2)"
                >规格追加填充↓</el-button
                >
                <el-button
                    size="large"
                    plain
                    class="jy-button"
                    @click="onComputeSpecifications"
                >规格汇总↑</el-button
                >
                <el-button
                    size="large"
                    plain
                    class="jy-button"
                    @click="seeAllSpecs"
                >查看全部规格</el-button
                >
                <el-button
                    size="large"
                    plain
                    class="jy-button"
                    @click="delSpecsMore"
                    v-if="this.selectedItemIndex !== -1"
                >移除规格</el-button
                >
              </div>


              <div
                  class="table-ground"
                  :style="'margin-top: 20px'"
              >
                <el-table
                    ref="mytable"
                    header-align="center"
                    border
                    stripe
                    style="width: 100%"
                    :data="selectedItemIndex === -1 ? allSpecifications : (selectionGargoInformationRow ? selectionGargoInformationRow.itemSpecs : [])"
                    :header-cell-style="{ background: '#f0f0f0' }"
                    :row-class-name="(index) => index === selectedItemIndex ? 'highlight-row' : ''"
                >
                  <el-table-column type="selection" width="30" align="center"></el-table-column>
                  <el-table-column
                      fixed="left"
                      align="center"
                      label="序号"
                      type="index"
                      width="60"
                  ></el-table-column>
                  <el-table-column align="center" prop="goodsName" label="品名">
                    <template slot-scope="scope">
                      <div class="wtl_displayFlex">
                        <el-input
                            disabled
                            size="mini"
                            v-model="scope.row.goodsName"
                            placeholder=""
                        ></el-input>
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" prop="goodsLength" label="长cm">
                    <template slot-scope="scope">
                      <div class="wtl_displayFlex">
                        <el-input
                            size="mini"
                            type="number"
                            v-model="scope.row.goodsLength"
                            placeholder="请输入"
                        ></el-input>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" prop="goodsWide" label="宽cm">
                    <template slot-scope="scope">
                      <div class="wtl_displayFlex">
                        <el-input
                            size="mini"
                            type="number"
                            v-model="scope.row.goodsWide"
                            placeholder="请输入"
                        ></el-input>
                      </div>
                    </template>

                  </el-table-column>
                  <el-table-column align="center" prop="goodsHeight" label="高cm">
                    <template slot-scope="scope">
                      <div class="wtl_displayFlex">
                        <el-input
                            size="mini"
                            type="number"
                            v-model="scope.row.goodsHeight"
                            placeholder="请输入"
                        ></el-input>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" prop="packageCount" label="件数">
                    <template slot-scope="scope">
                      <div class="wtl_displayFlex">
                        <el-input
                            size="mini"
                            type="number"
                            v-model="scope.row.packageCount"
                            placeholder="请输入"
                            @input="onComputeSpecsParameter(scope.row, scope.$index)"
                        ></el-input>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" prop="volume" label="入仓体积/m³" width="200">
                    <template slot-scope="scope">
                      <div class="wtl_displayFlex">
                        <el-input
                            size="mini"
                            type="number"
                            v-model="scope.row.volume"
                            placeholder="请输入"
                        >

                        </el-input>
                        <div
                            class="totBtns"
                            @click="onComputeSpecsParameter(scope.row, scope.$index)"
                        >
                          计算
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                      align="center"
                      prop="f99"
                      label="操作"
                      fixed="right"
                      width="200"
                  >
                    <template slot-scope="scope">
                      <div class="rowflexbox">
                        <el-button
                            link
                            v-if="selectedItemIndex !== -1 && (
                        selectionGargoInformationRow
                          ? selectionGargoInformationRow.itemSpecs
                              .length ===
                            scope.$index + 1
                          : false)
                      "
                            @click="onAddSpecsList"
                            size="mini"
                            style="padding: 7px 10px; font-size: 12px;"
                        >增加</el-button
                        >
                        <el-popconfirm
                            v-if="selectedItemIndex !== -1 "
                            title="确定移除该行吗"
                            @confirm="onDelSpecsList(scope.$index)"
                            size="mini"
                        >
                          <template #reference>
                            <el-button style="padding: 7px 10px; font-size: 12px;" link>移除</el-button>
                          </template>
                        </el-popconfirm>
                        <el-button
                            v-if="selectedItemIndex !== -1 "
                            size="mini"
                            link
                            @click="onCopySpecsList(scope.$index, scope)"
                            style="padding: 7px 10px; font-size: 12px;"
                        >复制</el-button
                        >
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </el-card>


      <!-- 图片() -->
      <!-- <div class="M">
        <el-upload
          class="upload-demo"
          :action="activeUrl"
          list-type="picture-card"
          :limit="limitCount"
          :accept="'image/*'"
          :on-preview="handlePictureCardPreview"
          :on-remove="handleRemove"
          :http-request="uploadSectionFile"
          :file-list="fileList"
          :class="{ hide: hideUpload }"
        >
          <i class="el-icon-plus"></i>
          <div class="el-upload__tip" slot="tip">上传图片</div>
        </el-upload>
        <el-dialog
          width="60%"
          close-on-click-modal
          :visible.sync="dialogVisible"
        >
          <img width="80%" :src="dialogImageUrl" alt="" />
        </el-dialog>
      </div> -->
      <!-- 寄件人信息()  -->
      <div class="M newForm">
        <el-form
            ref="sendAddress"
            :model="sendAddress"
            :rules="newFormRules2"
            label-width="100px"
        >
          <div class="inlineDiv">
            <el-button
                style="margin: 0 10px 10px"
                type="primary"
                size="mini"
                @click="changeAddress('ji')"
            >选择寄件地址</el-button
            >
          </div>
          <div class="inlineDiv">
            <div class="queryItem1">
              <el-form-item label="寄件人:" prop="fullName">
                <el-input
                    v-model="sendAddress.fullName"
                    placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
            <div class="queryItem1">
              <el-form-item label="公司名称:" prop="companyName">
                <el-input
                    v-model="sendAddress.companyName"
                    placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
            <div class="queryItem1">
              <el-form-item label="联系电话:" prop="phone">
                <el-input
                    v-model="sendAddress.phone"
                    placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="inlineDiv">
            <!-- <div class="queryItem1">
                  <el-form-item label="联系手机:" prop="aa4">
                    <el-input
                      v-model="sendAddress.aa4"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </div> -->
            <!-- <div class="queryItem1">
                  <el-form-item label="地区:" prop="selectedOptions">
                    <el-cascader
                      clearable
                      size="large"
                      :options="regionData"
                      v-model="selectedOptions"
                      @change="handleChange"
                    >
                    </el-cascader>
                  </el-form-item>
                </div> -->
            <div class="queryItem1">
              <el-form-item label="国家/地区:" prop="areaCountryId">
                <el-select
                    filterable
                    clearable
                    v-model="sendAddress.areaCountryId"
                    placeholder="请选择"
                >
                  <el-option
                      v-for="item in areaCountList"
                      :key="item.areaCountryId"
                      :label="item.showName"
                      :value="item.areaCountryId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="queryItem1">
              <el-form-item label="州/省:" prop="provinceName">
                <el-input
                    v-model="sendAddress.provinceName"
                    placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
            <div class="queryItem1">
              <el-form-item label="城市:" prop="cityName">
                <el-input
                    v-model="sendAddress.cityName"
                    placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="inlineDiv">
            <div class="queryItem1">
              <el-form-item label="邮编:" prop="postalCode">
                <el-input
                    v-model="sendAddress.postalCode"
                    placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
            <div class="queryItem1" style="width: 62%">
              <el-form-item label="详细地址:" prop="address">
                <el-input
                    v-model="sendAddress.address"
                    placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <!-- 收件人信息 () -->
      <div class="M newForm">
        <el-form
            ref="receiveAddress"
            :model="receiveAddress"
            :rules="newFormRules3"
            label-width="100px"
        >
          <div class="inlineDiv">
            <el-button
                style="margin: 0 10px 10px"
                type="primary"
                size="mini"
                @click="changeAddress('shou')"
            >选择收货地址</el-button
            >
          </div>
          <div class="inlineDiv">
            <div class="queryItem1">
              <el-form-item label="收件人:" prop="fullName">
                <el-input
                    v-model="receiveAddress.fullName"
                    placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
            <div class="queryItem1">
              <el-form-item label="公司名称:" prop="companyName">
                <el-input
                    v-model="receiveAddress.companyName"
                    placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
            <div class="queryItem1">
              <el-form-item label="联系电话:" prop="tel">
                <el-input
                    v-model="receiveAddress.phone"
                    placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="inlineDiv">
            <!-- <div class="queryItem1">
                  <el-form-item label="联系手机:" prop="phone">
                    <el-input
                      v-model="receiveAddress.phone"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </div> -->
            <div class="queryItem1">
              <el-form-item label="国家/地区:" prop="areaCountryId">
                <el-select
                    filterable
                    clearable
                    v-model="receiveAddress.areaCountryId"
                    placeholder="请选择"
                >
                  <el-option
                      v-for="item in areaCountList"
                      :key="item.areaCountryId"
                      :label="item.showName"
                      :value="item.areaCountryId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="queryItem1">
              <el-form-item label="州/省:" prop="provinceName">
                <el-input
                    v-model="receiveAddress.provinceName"
                    placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
            <div class="queryItem1">
              <el-form-item label="城市:" prop="cityName">
                <el-input
                    v-model="receiveAddress.cityName"
                    placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <!-- <div class="inlineDiv">
                <div class="queryItem1">
                  <el-form-item label="区域:" prop="areaName">
                    <el-input
                      v-model="receiveAddress.areaName"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </div>

              </div> -->
          <div class="inlineDiv">
            <div class="queryItem1">
              <el-form-item label="邮编:" prop="postalCode">
                <el-input
                    v-model="receiveAddress.postalCode"
                    placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
            <div class="queryItem1" style="width: 62%">
              <el-form-item label="详细地址:" prop="address">
                <el-input
                    v-model="receiveAddress.address"
                    placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div class="M newForm">
        <AngleDouble title="附件信息">
          <commonFuJian ref="domCommonFuJian" :data = "annexTable"></commonFuJian>

        </AngleDouble>
      </div>
    </div>



    <!-- 会员管理 -->
    <el-dialog
        title="会员管理"
        :visible.sync="isDT"
        width="50%"
        :close-on-click-modal="false"
        @close="handleClose"
    >
      <div class="newForm">
        <div class="formS">
          <el-form
              ref="vf"
              size="mini"
              :model="vf"
              :rules="vfr"
              label-width="80px"
          >
            <el-row>
              <el-col :span="19" style="display: flex">
                <div class="queryItem1">
                  <el-form-item label="会员号:" prop="memberId">
                    <el-input clearable v-model="vf.memberId"></el-input>
                  </el-form-item>
                </div>
                <div class="queryItem1">
                  <el-form-item label="会员名称:" prop="nickname">
                    <el-input clearable v-model="vf.nickname"></el-input>
                  </el-form-item>
                </div>
                <!-- <div class="queryItem1">
                    <el-form-item label="仓库:" prop="memberId">
                      <el-select
                        v-model="vf.memberId"
                        placeholder="请选择活动区域"
                      >
                        <el-option label="区域一" value="shanghai"></el-option>
                        <el-option label="区域二" value="beijing"></el-option>
                      </el-select>
                    </el-form-item>
                  </div> -->
              </el-col>
              <el-col :span="1">
                <el-form-item label-width="10px">
                  <el-button type="warning" @click="cxEdit">查 询</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="tableBox">
          <el-table
              :data="huiyuanList_dis"
              size="mini"
              max-height="400px"
              border
              style="width: 100%"
          >
            <el-table-column
                type="index"
                label="序号"
                align="center"
                width="50"
            >
            </el-table-column>
            <el-table-column
                prop="memberId"
                label="会员号"
                align="center"
                min-width="100"
            >
            </el-table-column>
            <el-table-column
                prop="nickname"
                label="会员名称"
                align="center"
                min-width="120"
            >
            </el-table-column>

            <el-table-column
                fixed="right"
                label="操作"
                align="center"
                min-width="100"
            >
              <template slot-scope="scope">
                <el-button
                    type="text"
                    style="color: #ef7c1b"
                    size="mini"
                    @click="xz(scope.row)"
                >选 择
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页组件 -->
          <paging
              ref="pags"
              :pageNum="pageNum"
              :total="total"
              :sizeList="sizeList"
              :size="size"
              @handleSizeChange="handleSizeChange"
              @handleCurrentChange="handleCurrentChange"
          ></paging>
        </div>
      </div>
    </el-dialog>

    <!-- 会员地址 -->
    <el-dialog
        title="会员地址"
        :visible.sync="isshowAddress"
        width="60%"
        @close="handleClose_address"
    >
      <!-- 表格 -->
      <div class="displayFlex">
        <h4>当前会员: {{ newForm.nickname }} ( {{ newForm.memberId }} )</h4>
        <!-- <el-button type="primary" size="mini" @click="addAddressBtns">新建地址</el-button> -->
      </div>
      <div class="tableBox" style="width: 99%; padding: 0" ref="tableWrapper">
        <el-table
            ref="mytable"
            @row-click="rowclick"
            :data="tableData"
            :row-class-name="tableRowClassName"
            highlight-current-row
            :header-cell-style="{ background: '#f0f0f0' }"
            border
            @selection-change="handleSelectionChange"
        >
          <el-table-column fixed="left" label="序号" type="index" width="60">
          </el-table-column>
          <el-table-column fixed="left" type="selection" width="60">
          </el-table-column>
          <template v-for="(item, index) in myTableHeard">
            <el-table-column
                :key="index"
                sortable
                :label="item.name"
                :prop="item.field"
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-if="item && item.isShow"
            >
            </el-table-column>
          </template>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="isshowAddress = false">取 消</el-button> -->
        <el-button type="primary" @click="confirmAddressBtns(selectAddressType)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Api } from "@/assets/js/api";
import tools from "@/assets/js/tool";
import paging from "@/components/pagings.vue";
import MathNumBer from "@/assets/js/MathNumBer";
import commonFuJian from "@/components/fuJian/index.vue";
// 详情页排版通用组件
import AngleDouble from '@/components/details/angleDouble.vue';
// 省市区数据
// import { regionData, CodeToText, TextToCode } from "element-china-area-data";
export default {
  components: {
    AngleDouble,     // ✅ 必须注册
    commonFuJian,
    paging
  },
  inject: ["reload"],
  data() {
    return {
      errorIndex: -1,
      selectedItemIndex: -1, // 当前选中的货物索引，默认-1表示未选择任何项
      selectionGargoInformationRow: null, // 当前选中行的货物信息
      allSpecifications: [], //所有的规格
      cutting: "", //批量添加要切割的字符串
      BatchAdd: {
        memberId: "",
        packageInfo: [
          {
            courierNumber: "",
            itemName: "",
            quantity: "",
            unitPrice: "",
          },
        ],
      },
      memberNickname: "",
      //    ------------ new ------------
      activeName: "first", //  tab标识
      newForm: {
        courierNumber: "",
        expressName: "",
        memberId: "",
        itemCategoryCode: "",
        storageId: "",
        itemReqs: [
          //物品数据
          {
            operationType : "ADD",
            itemId: "", //  序号
            serialNumber: 1, //  序号
            boxNo: "", //  箱号
            shippingMarkNo: "", //  唛头
            itemNameCode: "", //  物品名
            itemName: "", //  物品名称
            unitPrice: "", //  单价
            quantity: 1, //  数量
            intoStorageCount: 0, //  入库件数
            weight: "", //重量
            intoStorageWeight: "", //入库重量
            volume: "", //体积
            intoStorageVolume: "", //入库体积
            specs: "", //规格汇总
            itemSpecs:[
              {
                operationType : "ADD",
                specsId: "",
                serialNumber: 1, //  序号
                packageCount: 1, //  件数
                goodsLength: "", //  长(cm)
                goodsWide: "", //  宽(cm)
                goodsHeight: "", //  高(cm)
                volume: "", //  体积
              }
            ]
          },
        ],

        //  包裹预报表单数据
        isPrecious: "",
        comment: "", //备注
        packageId: "",
        loanStatus: "",

        nickname: "",

        length: "",
        width: "",
        height: "",
        boxCount: "",
        packageWeight: "",

      },
      oldItemReqs: [
        //物品数据
        {
          operationType : "ADD",
          itemId: "", //  序号
          serialNumber: 1, //  序号
          boxNo: "", //  箱号
          shippingMarkNo: "", //  唛头
          itemNameCode: "", //  物品名
          itemName: "", //  物品名称
          unitPrice: "", //  单价
          quantity: 1, //  数量
          intoStorageCount: 0, //  入库件数
          weight: "", //重量
          intoStorageWeight: "", //入库重量
          volume: "", //体积
          intoStorageVolume: "", //入库体积
          specs: "", //规格汇总
          itemSpecs:[
            {
              operationType : "ADD",
              specsId: "",
              serialNumber: 1, //  序号
              packageCount: 1, //  件数
              goodsLength: "", //  长(cm)
              goodsWide: "", //  宽(cm)
              goodsHeight: "", //  高(cm)
              volume: "", //  体积
            }
          ]
        },
      ],
      annexTable: [],
      fileNames: [],
      newFormRules: {
        memberId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        itemCategoryCode: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
      }, //  包裹预报表单规则配置
      newFormRules_2: {
        transportId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        channelId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        handoverMode: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
      }, //
      newFormRules1: {}, //
      newFormRules2: {}, //
      newFormRules3: {
        areaCountryId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
      }, //
      newFormRules4: {
        transportId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
      }, //
      cangkuList: [], //  仓库列表
      qudaoList: [], //  渠道品类列表
      qudaoNameList: [], //  渠道品类列表
      expressList: [], //  快递公司列表
      //  会员管理
      isDT: false,
      vf: {},
      vfr: {},
      huiyuanList: [],
      huiyuanList_dis: [],
      pageNum: 1,
      total: 0,
      size: 20,
      sizeList: [10, 20, 50, 100, 200],
      isJunp: false, //  页面是否要跳转标识
      empty: false, //拼团
      Collage: false, //拼团
      form: {
        name: "",
        delivery: false,
      },
      packageId: "",
      billPackId: "",

      //  上传配置
      limitCount: 10,
      fileList: [],
      activeUrl: "",
      dialogImageUrl: "",
      dialogVisible: false,
      hideUpload: false,

      pageStyle: "",

      NoHuoMao: false, //货猫的==false
      // radioStyle: 0, //直接转运
      checked1: false, //直接转运
      checked2: false, //直接转运
      // regionData: regionData, //中国,地区数据
      selectedOptions: [],
      regionFormData: {
        province: "",
        city: "",
        area: "",
      },

      // 会员弹窗部分====s
      checkList: [],
      isshowAddress: false, //地址弹窗
      myTableHeard: [
        {
          name: "公司名称",
          field: "corporateName",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收件人",
          field: "fullName",
          width: "120",
          sort: 3,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "联系电话",
          field: "phone",
          width: "120",
          sort: 3,
          isShow: true,
          isTotal: false,
        },
        {
          name: "邮政编号",
          field: "postalCode",
          width: "80",
          sort: 4,
          isShow: true,
          isTotal: false,
        },
        {
          name: "国家",
          field: "chineseName",
          width: "100",
          sort: 5,
          isShow: true,
          isTotal: false,
        },
        {
          name: "州/省",
          field: "provinceName",
          width: "100",
          sort: 6,
          isShow: true,
          isTotal: false,
        },
        {
          name: "城市",
          field: "cityName",
          width: "100",
          sort: 7,
          isShow: true,
          isTotal: false,
        },
        {
          name: "地址",
          field: "address",
          width: "160",
          sort: 8,
          isShow: true,
          isTotal: false,
        },
      ],
      tableData: [],
      userId: "",
      selectTableData: [],
      // 会员弹窗部分=====end

      // 收件人信息
      receiveAddress: {
        fullName: "",
        companyName: "",
        phone: "",
        areaCountryId: "",
        postalCode: "",
        provinceName: "",
        cityName: "",
        // areaName: "",
        userAddressId: "",
        address: "",
        // tel: "",
      },
      areaCountList: [],
      serveArr: [],

      // 申请打包信息，渠道之类的
      applyPackInfo: {
        billPackId: "",
        waybillNumber: "", //运单号
        transportId: "", //运输方式
        isCustomerCheckScale: 0, //数据确认类型
        paymentMethodStatus: "", //付款方式
        channelId: "", //渠道id
        customerNumber: "", //客户单号
        handoverMode: "", //提货方式(末端派送)
        withholdStatus: 0, //等通知放货
        estimatedFreight: "", //预计运费
        comment: "",
        itemServicesInfo: [],
        receiveAddress: {},
      },

      // 寄件人信息
      sendAddress: {
        address: "",
        areaCountryId: "",
        areaName: "",
        cityName: "",
        companyName: "",
        fullName: "",
        phone: "",
        postalCode: "",
        provinceName: "",
        userAddressId: "",
        tel: "",
      },

      channelAndTransportList: [], //  渠道&运输方式下拉数据
      transportList: [], //  运输方式下拉菜单
      isCustomerCheckScaleList: [
        {
          value: 0,
          label: "仓库确认",
        },
        {
          value: 1,
          label: "客户确认",
        },
      ],
      withholdStatusList: [
        {
          value: 0,
          label: "放货",
        },
        {
          value: 1,
          label: "扣货",
        },
      ],
      selectAddressType: "shou", //选择地址类型 ji=寄件地址 shou=收件地址
      channelList: [], //  渠道方式下拉菜单
      payType: [], //  付款方式下拉菜单
      handoverModeList: [], //  提货方式
    };
  },
  watch: {
    checked1: {
      handler(a, b) {
        this.checked2 = false;
      },
    },
    "newForm.itemReqs": {
      handler(val) {
        let specs = [];
        val.forEach(item => {
          if (item.itemSpecs && item.itemSpecs.length > 0) {
            item.itemSpecs.forEach(spec => {
              spec.goodsName = item.itemName; // 同步更新 goodsName

              // 过滤掉所有字段都为空的规格
              const { goodsLength, goodsWide, goodsHeight, packageCount, volume } = spec;
              const hasValue = [goodsLength, goodsWide, goodsHeight, packageCount, volume].some(
                  field => field !== null && field !== undefined && field !== ""
              );

              if (hasValue) {
                specs.push(spec);
              }
            });
          }
          this.updateSpecsForSelectedItem(item); // 删除后更新 specs
        });
        this.allSpecifications = specs;
      },
      deep: true,
      immediate: true
    }
    // "newForm.itemReqs": {
    //   handler(a, b) {
    //     console.log(a);
    //   },
    //   deep: true,
    // },
  },
  created() {
    this.getVipList();

    this.myGetStorageListPage(); //  获取仓库下拉列表
    this.myGetChannelItemCategoryList(); //  获取渠道品类
    this.myGetItemNameList(); //  获取渠道物品名称列表
    this.myGetExpressChooseList(); //  快递公司下拉列表
    this.getAreaContryList(); //  快递国家下拉列表
    this.getPackageServe(); //  打包服务
    this.getChannelAndTransportList(); //  获取渠道与运输方式下拉菜单

    this.myGetStatusValList("bill_pack_v1.payment_method_status", 1); //  付款方式
    this.getConfDictValDownList("handover_mode"); //  提货方式

    this.NoHuoMao = tools.NoHuoMao();
  },
  activated() {
    this.billPackId = this.$route.query.billPackId;
    if (this.billPackId) {
      this.pageStyle = "edit";
      this.myGetPackageDetail(); //  获取包裹详情
    }
  },
  mounted() {
  },
  methods: {
    // changeInput(e, idx) {
    //   this.$forceUpdate(); //强制渲染
    //   this.serveArr[idx].count = e;
    // },
    changeCheckBoxItem(e, idx) {
      if (this.serveArr[idx].operationType == "UPDATE") {
        this.serveArr[idx].operationType = e ? "UPDATE" : "DEL";
      }
      if (this.serveArr[idx].operationType == "DEL") {
        this.serveArr[idx].operationType = e ? "UPDATE" : "DEL";
      }
    },
    //自动填写
    fillbut() {
      Api.createChannelNumber().then((res) => {
        this.newForm.courierNumber =
            res.data.result.channelNumber || this.packageForm.packageStockNumber;
      });
    },
    // 付款方式 提货方式
    myGetStatusValList(status, type) {
      Api.getStatusValList({
        tableAndFieldName: status,
      }).then((res) => {
        if (type == 1) {
          //  获取付款方式
          this.payType = res.data.result || [];
        }
        // if (type == 2) {
        //   //  提货方式
        //   this.handoverModeList = res.data.result || [];
        // }
      });
    },
    getConfDictValDownList(status) {
      //  提货方式
      Api.getConfDictValDownList({
        dictType: status,
      }).then((res) => {
        let resultData = res.data.result || []
        if (status == 'handover_mode') {
          this.handoverModeList = resultData
        }
      })
    },
    getChannelAndTransportList() {
      //  获取渠道与运输方式下拉菜单
      Api.channelAndTransportList().then((res) => {
        let obj = {};
        this.transportList = res.data.result.reduce((cur, next) => {
          //  去重
          obj[next.channelTransportId]
              ? ""
              : (obj[next.channelTransportId] = true && cur.push(next));
          return cur;
        }, []);
        this.channelAndTransportList = res.data.result || [];
      });
    },
    selectTId(val) {
      //  选择下拉框时筛选渠道数据
      let arr = [];
      // this.applyPackInfo.channelId = "";
      this.channelAndTransportList.forEach((item) => {
        if (item.channelTransportId === val) {
          arr.push(item);
        }
      });
      this.channelList = arr;
    },

    //  获取服务打包项
    getPackageServe() {
      Api.getPackageServeApply().then((res) => {
        if (res.data.status === "success") {
          this.serveArr = res.data.result || [];
          this.serveArr.forEach((item) => {
            item.operationType = "ADD";
            // item.count = "";
          });
        } else {
          this.$message.error(`${res.data.message}--获取服务打包项`);
        }
      });
    },
    // 选择地区---------开始
    handleChange(value) {
      this.getCodeToText(null, value);
    },
    getCodeToText(codeStr, codeArray) {
      if (null === codeStr && null === codeArray) {
        return null;
      } else if (null === codeArray) {
        codeArray = codeStr.split(",");
      }
      this.regionFormData.province = CodeToText[codeArray[0]];
      this.regionFormData.city = CodeToText[codeArray[1]];
      this.regionFormData.area = CodeToText[codeArray[2]];

      let area =
          CodeToText[codeArray[0]] +
          "/" +
          (CodeToText[codeArray[1]] || "") +
          "/" +
          (CodeToText[codeArray[2]] || "");
      return area;
    },
    // 选择地区---------结束

    //  ----------- 图片上传 start--------------
    // 上传图片
    uploadSectionFile(param) {
      const file = param.file;
      const fileName = file.name;
      const form = new FormData(); // 根据后台需求数据格式
      form.append("file", file); // 文件对象
      form.append("fileName", fileName); // 本例子主要要在请求时添加特定属性，所以要用自己方法覆盖默认的action
      let signArr = [
        {
          key: "fileName",
          val: fileName,
        },
      ];
      let sign = tools.getMD5Sign(signArr);
      form.append("sign", sign);
      Api.uploadFile(form).then((res) => {
        if (res.data.status === "success") {
          this.fileList.push({
            name: res.data.result.fileName,
            uid: res.data.result.redirectUrl,
            url: res.data.result.url,
          });
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    //  图片上传事件
    handleRemove(file, fileList) {
      /* 移除图片 */
      this.fileList = fileList;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //  ----------- 图片上传  end--------------

    // 选择品名
    changeItem(e, idx) {
      if (!e) {
        this.newForm.itemReqs[idx].itemName = "";
      }
      let code = e;
      this.qudaoNameList.forEach((item) => {
        if (item.itemNameCode == code) {
          this.newForm.itemReqs[idx].itemName = item.showName;
        }
      });
    },
    // 选择会员
    huiayu(e) {
      if (!e) {
        this.newForm.nickname = "";
        this.newForm.memberId = "";
        this.userId = "";
        this.getVipList();
        return false;
      }
      this.huiyuanList.forEach((item) => {
        if (e == item.memberId) {
          this.newForm.nickname = item.nickname;
          this.userId = item.userId;
        }
      });
    },
    // 选择会员
    huiayuName(e) {
      if (!e) {
        this.newForm.nickname = "";
        this.newForm.memberId = "";
        this.userId = "";
        this.getVipList();
        return false;
      }
      this.huiyuanList.forEach((item) => {
        if (e == item.nickname) {
          this.newForm.memberId = item.memberId;
          this.userId = item.userId;
        }
      });
    },


    // 入库信息参数计算
    onComputeSpecsParameter (row, index){
      let h = parseFloat(row.goodsHeight);
      let w = parseFloat(row.goodsWide);
      let l = parseFloat(row.goodsLength);
      let c = parseFloat(row.packageCount);
      if (isNaN(h) || isNaN(w) || isNaN(l) || isNaN(c)) {
        this.$message.warning('长或宽或高或件数不能留空，也不能是非数字');
        return;
      } else {
        this.selectionGargoInformationRow.itemSpecs[index].volume = (
            (h * w * l * c) /
            1000000
        ).toFixed(3);
      }
    },


    totleVolume(idx, row) {
      let arr = this.selectionGargoInformationRow.itemSpecs;
      for (let i = 0; i < arr.length; i++) {
        const value = arr[i];
        let h = parseFloat(value.goodsHeight);
        let w = parseFloat(value.goodsWide);
        let l = parseFloat(value.goodsLength);
        let c = parseFloat(value.packageCount);
        if (isNaN(h) || isNaN(w) || isNaN(l) || isNaN(c)) {
          this.$message.warning('规格长或宽或高或件数不能留空，也不能是非数字');
          return;
        }
      }
      let volumes = 0;
      arr.forEach((value, key) => {
        let h = parseFloat(value.goodsHeight);
        let w = parseFloat(value.goodsWide);
        let l = parseFloat(value.goodsLength);
        let c = parseFloat(value.packageCount);
        let all = (h * w * l * c) / 1000000;
        volumes = volumes + all;
      });
      this.selectionGargoInformationRow.volume = volumes.toFixed(
          3
      );
    },
    //批量添加提交
    Submit() {
      let textarea = this.cutting;
      var String = [];
      String.push(textarea);

      let datsArr = String[0].split("\n") || [];
      if (datsArr.length <= 0) {
        return;
      }
      let flag = /\s/; //所有空白字符
      let newArr = []; //切割后的数组
      for (var i = 0; i < datsArr.length; i++) {
        if (datsArr[i]) {
          let strArr = datsArr[i].split(flag);
          let arr1 = [];
          for (var z = 0; z < strArr.length; z++) {
            if (strArr[z]) {
              arr1.push(strArr[z]);
            }
          }
          newArr.push(arr1);
        }
      }
      if (newArr.length == 0) {
        return;
      }
      //console.log(newArr);
      let pArr = [];
      for (var a = 0; a < newArr.length; a++) {
        let bArr = newArr[a] || [];
        let number = bArr[2] || 0;
        var obj = {
          courierNumber: bArr[0] || "",
          itemName: bArr[1] || "",
          quantity: Math.round(number * 100) / 100,
          unitPrice: bArr[3] || "",
        };
        pArr.push(obj);
      }
      console.log(pArr);
      this.BatchAdd.packageInfo = pArr || [];
      Api.batchAddPackage(this.BatchAdd).then((res) => {
        if (res.data.status == "success") {
          this.$message.success("添加成功");
          setTimeout(() => {
            this.Reset();
          }, 500);
        }
      });
    },
    //批量添加重置
    Reset() {
      this.cutting = "";
      this.BatchAdd = {
        memberId: "",
        packageInfo: [
          {
            courierNumber: "",
            itemName: "",
            quantity: "",
            unitPrice: "",
          },
        ],
      };
    },
    myGetStorageListPage() {
      //  获取仓库下拉列表
      Api.getStorageList().then((res) => {
        if (res.data.status === "success") {
          this.cangkuList = res.data.result || [];
          if (this.cangkuList.length > 0) {
            this.newForm.storageId = this.cangkuList[0].id;
          }
        } else {
          this.$message.error(`${res.data.message}--仓库下拉列表API`);
        }
      });
    },
    myGetChannelItemCategoryList() {
      //  获取渠道品类
      Api.getItemCategoryListNoPage().then((res) => {
        if (res.data.status === "success") {
          this.qudaoList = res.data.result;
        } else {
          this.$message.error(`${res.data.message}--渠道品类列表API`);
        }
      });
    },
    // 获取货物品名
    myGetItemNameList() {
      Api.getItemNameList({
        pageStart: 1,
        pageTotal: 100,
        languageCode: tools.getLanguageCode(),
        itemNameCode: "",
      }).then((res) => {
        if (res.data.status === "success") {
          this.qudaoNameList = res.data.result.data || [];
        } else {
          this.$message.error(`${res.data.message}--渠道物品名称列表API`);
        }
      });
    },

    myGetExpressChooseList() {
      //  快递公司下拉列表
      Api.expressChooseList().then((res) => {
        if (res.data.status === "success") {
          this.expressList = res.data.result;
        } else {
          this.$message.error(`${res.data.message}--快递公司下拉列表`);
        }
      });
    },
    /**********************会员地址----------------- */
    // 获取国家地区列表
    getAreaContryList() {
      Api.getAreaContryList_q().then((res) => {
        let areaCountList = res.data.result || [];
        var showArr = [];
        //暂时不做中英文切换
        for (var i = 0; i < areaCountList.length; i++) {
          showArr.push({
            areaCountryId: areaCountList[i].areaCountryId,
            numberCode: areaCountList[i].numberCode,
            showName: areaCountList[i].chineseName,
          });
        }
        this.areaCountList = showArr;
      });
    },
    getData() {
      let that = this;
      Api.userAddressList({ userId: this.userId }).then((res) => {
        this.tableData = res.data.result || [];
        this.total = this.tableData.length || 0;
        that.$nextTick(() => {
          that.$refs.mytable.doLayout();
        });
      });
    },
    //分页
    handleSizeChange(val) {
      this.size = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getData();
    },
    //表格样式i
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
    },
    // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
      ////console.log(e);
    },
    // 选择地址
    changeAddress(selectAddressType) {
      this.selectAddressType = selectAddressType;
      if (this.userId) {
        this.isshowAddress = true;
        this.getData();
      } else {
        this.$message.warning("请先选择会员");
      }
    },
    // 确认地址
    confirmAddressBtns(selectAddressType) {
      if (this.selectTableData.length == 0) {
        this.$message.warning("请选择一条地址");
        return;
      }
      if (this.selectTableData.length > 1) {
        this.$message.warning("只能选择一条地址");
        return;
      }
      let datas = this.selectTableData[0];
      if(selectAddressType === 'shou'){
        this.receiveAddress.fullName = datas.fullName || "";
        this.receiveAddress.companyName = datas.corporateName || "";
        this.receiveAddress.phone = datas.phone || "";
        this.receiveAddress.areaCountryId = datas.areaCountryId || "";
        this.receiveAddress.postalCode = datas.postalCode || "";
        this.receiveAddress.provinceName = datas.provinceName || "";
        this.receiveAddress.cityName = datas.cityName || "";
        // this.receiveAddress.areaName = "";
        this.receiveAddress.userAddressId = datas.userAddressId || "";
        this.receiveAddress.address = datas.address || "";
      }else if(selectAddressType === 'ji'){
        this.sendAddress.fullName = datas.fullName || "";
        this.sendAddress.companyName = datas.corporateName || "";
        this.sendAddress.phone = datas.phone || "";
        this.sendAddress.areaCountryId = datas.areaCountryId || "";
        this.sendAddress.postalCode = datas.postalCode || "";
        this.sendAddress.provinceName = datas.provinceName || "";
        this.sendAddress.cityName = datas.cityName || "";
        this.sendAddress.userAddressId = datas.userAddressId || "";
        this.sendAddress.address = datas.address || "";
      }

      this.isshowAddress = false;
    },
    handleClose_address() {},

    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
      // @row-click="rowclick"
    },

    /**********************会员地址----------------- */



    // 计算规格
    onComputeSpecifications () {
      let arr = this.selectionGargoInformationRow.itemSpecs;
      for (let i = 0; i < arr.length; i++) {
        const value = arr[i];
        let h = parseFloat(value.goodsHeight);
        let w = parseFloat(value.goodsWide);
        let l = parseFloat(value.goodsLength);
        let c = parseFloat(value.packageCount);
        if (isNaN(h) || isNaN(w) || isNaN(l) || isNaN(c)) {
          this.$message.warning('规格的长或宽或高或件数不能留空，也不能是非数字');
          return;
        }
      }
      let newstr = "";
      arr.forEach((value, key) => {
        let h = parseFloat(value.goodsHeight);
        let w = parseFloat(value.goodsWide);
        let l = parseFloat(value.goodsLength);
        let c = parseFloat(value.packageCount);
        let str = l + "*" + w + "*" + h + "*" + c + "+";
        newstr = newstr + str;
      });
      newstr = newstr.slice(0, -1);
      this.selectionGargoInformationRow.specs = newstr;
    },

    // 规格填充（根据 specs 自动填充）
    onInputSpecifications(isReplace) {
      const specsStr = this.selectionGargoInformationRow.specs;

      if (!specsStr) {
        this.$message.warning('货物信息中的规格汇总 内容不能为空');
        return;
      }
      let indexBegin = 0;
      // 清空现有的规格列表
      if(isReplace===1) {
        this.selectionGargoInformationRow.itemSpecs.length = 0;
      }
      else{
        indexBegin = this.selectionGargoInformationRow.itemSpecs.length;
      }
      try {
        const specsArray = specsStr.split(/[+,，;；]/);;
        let hasError = false;
        let errorMessage = "";
        this.errorIndex = -1;

        for (let i = 0; i < specsArray.length; i++) {

          const spec = specsArray[i].trim();

          // 检查是否符合格式：四个数字以 * 分隔
          const regex = /^(\d+\.?\d*)\*(\d+\.?\d*)\*(\d+\.?\d*)\*(\d+\.?\d*)$/;
          const match = spec.match(regex);

          if (!match) {
            hasError = true;
            errorMessage = errorMessage + `第 ${i + 1 + indexBegin} 行格式错误：“${spec}” 不符合“长*宽*高*件数”的格式`;
            this.errorIndex = i;
            console.log('当前错误行索引:', this.errorIndex);
            // continue; // 跳过当前项，继续处理后面的项
          }

          const [_, length, width, height, count] = match;

          // 校验是否为有效数字
          const goodsLength = Number(length);
          const goodsWide = Number(width);
          const goodsHeight = Number(height);
          const packageCount = Number(count);

          if (
              isNaN(goodsLength) ||
              isNaN(goodsWide) ||
              isNaN(goodsHeight) ||
              isNaN(packageCount)
          ) {
            hasError = true;
            errorMessage = errorMessage + `第 ${i + 1 + indexBegin} 行包含非数字内容：“${spec}”; `;
            this.errorIndex = i;
            console.log('当前错误行索引:', this.errorIndex);
            // continue;
          }

          // 校验件数是否为整数
          if (!Number.isInteger(packageCount)) {
            hasError = true;
            errorMessage = errorMessage + `第 ${i + 1 + indexBegin} 行的件数必须为整数：“${spec}”; `;
            this.errorIndex = i;
            console.log('当前错误行索引:', this.errorIndex);
            // continue;
          }

          // 推入新规格项（即使前面有错误，也保留已解析成功的数据）
          this.selectionGargoInformationRow.itemSpecs.push({
            goodsName: this.selectionGargoInformationRow.itemName,
            goodsLength,
            goodsWide,
            goodsHeight,
            packageCount,
            volume: ((goodsLength * goodsWide * goodsHeight * packageCount) / 1e6).toFixed(
                3
            ),
          });
        }

        if (hasError) {
          this.$message.error(errorMessage);
          console.warn(`错误发生在第 ${this.errorIndex + 1} 行：${specsArray[this.errorIndex]}`);
        } else {
          this.$message.success("规格填充成功");
        }

        // 无论是否有错误，都重新计算体积
        this.totleVolume();
      } catch (error) {
        this.$message.error("规格解析失败，请检查输入格式");
        console.error(error);
      }
    },
    saveData() {
      // 处理服务费项
      let checkList = this.checkList;
      let itemServicesInfo = [];
      for (var a = 0; a < this.serveArr.length; a++) {
        for (var b = 0; b < checkList.length; b++) {
          if (this.serveArr[a].itemServiceId == checkList[b]) {
            let obj = {
              itemServiceId: this.serveArr[a].itemServiceId,
              itemServiceTitle: this.serveArr[a].title,
              unitPrice: this.serveArr[a].unitPrice,
              count: this.serveArr[a].count,
              operationType: this.serveArr[a].operationType,
            };
            itemServicesInfo.push(obj);
          }
        }
      }
      //删除的费项也要提交给后台
      this.serveArr.forEach((item) => {
        if (item.operationType == "DEL") {
          let obj = {
            itemServiceId: item.itemServiceId,
            itemServiceTitle: item.title,
            unitPrice: item.unitPrice,
            count: item.count,
            operationType: item.operationType,
          };
          itemServicesInfo.push(obj);
        }
      });
      // 申请打包信息
      let applyPackInfoParam = this.applyPackInfo;
      applyPackInfoParam.itemServicesInfo = itemServicesInfo;
      applyPackInfoParam.receiveAddress = this.receiveAddress;

      let newForm = this.newForm;
      // // 是否贵重物品处理
      // if (newForm.isPrecious) {
      //   newForm.isPrecious = 1;
      // } else {
      //   newForm.isPrecious = 0;
      // }
      // 处理货物
      let arrItes = JSON.parse(JSON.stringify(this.newForm)) || {};
      let oldItemArr = this.oldItemReqs;
      let newItemArr = arrItes.itemReqs;
      let subItemArr = tools.transOperationType("itemId",newItemArr,oldItemArr);
      let itemCount = subItemArr.length;
      for (var i = 0; i < subItemArr.length; i++) {
        let subItem = subItemArr[i];
        subItem.quantity = subItem.quantity || 1;
        subItem.unitPrice = subItem.unitPrice || 0;
        if (subItem.itemName === "") {
          subItemArr.splice(i, 1);
          i--;
        }
        //处理货物规格
        let subItemSpecs = subItem.itemSpecs;
        let operationType = subItem.operationType;
        if("ADD" === operationType){
          subItem.itemSpecs = tools.transOperationType("specsId",subItemSpecs,[]);
        }else if("DEL" === operationType){

        }else{
          //从oldItemArr中根据itemId===subItem.itemId过滤获取原始的货物
          const oldItem = oldItemArr.find(oldItem => oldItem.itemId === subItem.itemId);
          if(oldItem){
            //获取原始的货物规格
            let oldItemSpecs = oldItem.itemSpecs;
            //处理操作状态
            subItem.itemSpecs = tools.transOperationType("specsId",subItemSpecs,oldItemSpecs)
          }
        }
      }


      // 图片
      // this.fileList.forEach((item) => {
      //   this.fileNames.push(item.name);
      // });
      const fuJianComponent = this.$refs.domCommonFuJian;
      console.info("domCommonFuJian",fuJianComponent)
      let files = fuJianComponent.annexTable || [];
      let DELFilesList = fuJianComponent.DELFilesList || [];
      let fileLists = [...files, ...DELFilesList].map(item => ({
        fileId: item.fileId,
        fileName: item.fileName,
        operationType: item.operationType,
      }));

      // 包裹信息
      let packageInfo = arrItes;
      packageInfo.itemReqs = subItemArr;
      packageInfo.loanStatus = this.newForm.loanStatus
          ? "dian_fu::loan_status"
          : "bu_dian_fu:loan_status";
      packageInfo.doorStatus = this.checked2 ? "need_shang_men:door_status " : "";

      let paraV2 = {
        applyPackInfo: applyPackInfoParam,
        packageInfo: packageInfo,
        sendAddress: this.sendAddress,
        files: fileLists,
      };

      paraV2.sign = tools.getSign(paraV2);
      Api.addDaHuoV4(paraV2)
          .then((res) => {
            // this.$message.success(res.data.message || "新建成功");

            this.reload();
            this.$router.push("/pages/v4/daHuo/daHuoList");
          })
          .catch(() => {});
    },
    // 批量删除规格
    delSpecsMore() {
      // if (this.selectedItemIndex === -1) {
      //   // 查看的是全部规格
      //   if (!this.$refs.mytable || !this.$refs.mytable.selection || this.$refs.mytable.selection.length === 0) {
      //     this.$message.warning('请先选择要删除的规格');
      //     return;
      //   }
      //
      //   this.$confirm('确定要删除所选规格吗？', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     const selectedRows = this.$refs.mytable.selection;
      //     // 从 allSpecifications 中过滤掉被选中的行
      //     this.allSpecifications = this.allSpecifications.filter(spec => !selectedRows.includes(spec));
      //     this.$message.success('删除成功');
      //   }).catch(() => {});
      // } else {
      // 查看的是某个货物的规格
      if (!this.$refs.mytable || !this.$refs.mytable.selection || this.$refs.mytable.selection.length === 0) {
        this.$message.warning('请先选择要移除的规格');
        return;
      }

      this.$confirm('确定要移除所选规格吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const selectedRows = this.$refs.mytable.selection;
        // 从当前货物的规格中过滤掉被选中的行
        this.selectionGargoInformationRow.itemSpecs = this.selectionGargoInformationRow.itemSpecs.filter(
            spec => !selectedRows.includes(spec)
        );
        this.$message.success('规格移除成功');
      }).catch(() => {});
      // }
    },

    //点击货物事件=>展示对应的规格
    handleRowClick(row, event, column) {
      const index = this.newForm.itemReqs.findIndex(item => item === row);
      this.selectedItemIndex = index;
      this.selectionGargoInformationRow = row;
      if(!this.selectionGargoInformationRow.itemSpecs || this.selectionGargoInformationRow.itemSpecs.length === 0){
        this.selectionGargoInformationRow.itemSpecs =[
          {
            goodsName: row.itemName, //  品名
            serialNumber: 1, //  序号
            packageCount: 1, //  件数
            goodsLength: "", //  长(cm)
            goodsWide: "", //  宽(cm)
            goodsHeight: "", //  高(cm)
            volume: "", //  体积
          }
        ]
      } else {
        // 同步更新所有规格的 goodsName 为当前货物品名
        this.selectionGargoInformationRow.itemSpecs.forEach(spec => {
          spec.goodsName = row.itemName;
        });
      }
    },

    //查看全部规格
    seeAllSpecs() {
      this.selectedItemIndex = -1;
    },
    highlightRowClassName({ row, rowIndex }) {
      if (rowIndex === this.selectedItemIndex) {
        return 'highlight-row';
      }
      return '';
    },

    // 添加规格
    onAddSpecsList() {
      let item = {
        goodsName: this.selectionGargoInformationRow.itemName,
        length: "",
        wide: "",
        height: "",
        packageCount: "",
        volume: "",
      };
      this.selectionGargoInformationRow.itemSpecs.push(item);
    },

    // 移除规格
    onDelSpecsList (idx) {
      this.selectionGargoInformationRow.itemSpecs.splice(idx, 1);
      this.updateSpecsForSelectedItem(this.selectionGargoInformationRow); // 删除后更新 specs
    },

    updateSpecsForSelectedItem(itemRow) {
      if (!itemRow || !itemRow.itemSpecs) return;

      let newstr = '';
      const specs = itemRow.itemSpecs;

      for (let i = 0; i < specs.length; i++) {
        const spec = specs[i];
        let h = parseFloat(spec.goodsHeight);
        let w = parseFloat(spec.goodsWide);
        let l = parseFloat(spec.goodsLength);
        let c = parseFloat(spec.packageCount);

        if (isNaN(h) || isNaN(w) || isNaN(l) || isNaN(c)) continue;

        newstr += `${l}*${w}*${h}*${c}+`;
      }

      newstr = newstr.slice(0, -1); // 去掉最后的 "+"
      itemRow.specs = newstr;

      // 同步更新 newForm.itemReqs 中的 specs
      const index = this.newForm.itemReqs.findIndex(
          item => item === itemRow
      );
      if (index !== -1) {
        this.newForm.itemReqs[index].specs = newstr;
      }
    },


    // 复制规格
    onCopySpecsList  (idx, row) {
      // 记得解除内存的占用
      let rowrow = JSON.parse(JSON.stringify(row.row));
      this.selectionGargoInformationRow.itemSpecs.splice(
          idx,
          0,
          rowrow
      );
      this.updateSpecsForSelectedItem(this.selectionGargoInformationRow); // 删除后更新 specs
    },











    //获取详情
    myGetPackageDetail() {
      let param = {
        conditionReqs: [
          {
            conditonKey: 'billPackId',
            conditonVal: this.billPackId,
          },
        ],
        number: 'big_goods_bill_detail_packages',
      }
      this.$API.runReport(param).then((res) => {

        if (res.data.result) {
          let results = res.data.result.datas || []
          let newForm = results[0];
          // this.newForm.courierNumber = newForm.courierNumber;
          this.newForm.expressName = newForm.expressName;
          this.newForm.memberId = newForm.memberId;
          this.newForm.nickname = newForm.memberName;
          this.memberNickname = newForm.memberName;
          this.newForm.storageId = newForm.storageId;
          this.newForm.itemCategoryCode = newForm.itemCategoryCode;
          this.newForm.packageId = newForm.packageId;
        } else {
          this.$message.error(`${res.data.message}--获取包裹详情API`);
        }
      });
      //货物货物
      param = {
        conditionReqs: [
          {
            conditonKey: 'billPackId',
            conditonVal: this.billPackId,
          },
        ],
        number: 'big_goods_bill_detail_packages_items',
      }
      this.$API.runReport(param).then((res) => {
        if (res.data.result) {
          let results = res.data.result.datas || []

          this.newForm.itemReqs = results.map(item => {
            let itemReq = {
                  itemId: item.itemId, //  序号
                  serialNumber: item.serialNumber, //  序号
                  boxNo: item.boxNo, //  箱号
                  shippingMarkNo: item.shippingMarkNo, //  唛头
                  itemNameCode: item.itemNameCode, //  物品名
                  itemName: item.itemName, //  物品名称
                  unitPrice: item.unitPrice, //  单价
                  quantity: item.quantity, //  数量
                  intoStorageCount: item.intoStorageCount, //  入库件数
                  weight: item.weight, //重量
                  intoStorageWeight: item.intoStorageWeight, //入库重量
                  volume: item.volume, //体积
                  intoStorageVolume: item.intoStorageVolume, //入库体积
                  specs: item.specs, //规格汇总
                  itemSpecs:item.itemSpecs,
                  operationType : "ADD",
                };
            return itemReq;
          });
        } else {
          this.$message.error(`${res.data.message}--获取包裹详情API`);
        }
      });
      //打包单信息
      param = {
        conditionReqs: [
          {
            conditonKey: 'billPackId',
            conditonVal: this.billPackId,
          },
        ],
        number: 'big_goods_bill_detail_pack_bill',
      }
      this.$API.runReport(param).then((res) => {
        if (res.data.result) {
          let results = res.data.result.datas || []
          let newForm = results[0];
          // waybillNumber: "", //运单号
          //     transportId: "", //运输方式
          //     isCustomerCheckScale: 0, //数据确认类型
          //     paymentMethodStatus: "", //付款方式
          //     channelId: "", //渠道id
          //     customerNumber: "", //客户单号
          //     handoverMode: "", //提货方式(末端派送)
          //     withholdStatus: 0, //等通知放货
          //     estimatedFreight: "", //预计运费
          //     comment: "",
          //     itemServicesInfo: [],
          //     receiveAddress: {},
          this.applyPackInfo.billPackId = this.billPackId;
          // this.applyPackInfo.waybillNumber = newForm.waybillNumber;
          this.applyPackInfo.transportId = newForm.transportId;
          this.applyPackInfo.isCustomerCheckScale = newForm.isCustomerCheckScale;
          this.applyPackInfo.paymentMethodStatus = newForm.paymentMethodStatus;
          this.applyPackInfo.channelId = newForm.channelId;
          // this.applyPackInfo.customerNumber = newForm.customerNumber;
          this.applyPackInfo.handoverMode = newForm.handoverMode;
          this.applyPackInfo.withholdStatus = newForm.withholdStatus;
          this.applyPackInfo.estimatedFreight = newForm.estimatedFreight;
          this.applyPackInfo.comment = newForm.comment;
          if(newForm.itemServicesInfo){
            this.applyPackInfo.itemServicesInfo =  newForm.itemServicesInfo.forEach(item => {
              let servicesInfo = {
                itemServiceId: item.itemServiceId,
                itemServiceTitle: item.title,
                unitPrice: item.unitPrice,
                count: item.count,
              };
              return servicesInfo;
            });
          }
          let serveList = [];
          newForm.itemServicesInfo.forEach((item) => {
            item.count = item.serviceCount;
            serveList.push(item.itemServiceId);
          });
          this.serveArr.forEach((item1) => {
            item1.count = "";
            item1.operationType = "ADD";
            newForm.itemServicesInfo.forEach((item2) => {
              if (item1.itemServiceId == item2.itemServiceId) {
                item1.count = item2.serviceCount;
                item1.operationType = "UPDATE";
              }
            });
          });
          this.checkList = serveList;
          if(newForm.receiveAddress){
            let resutlReAddr = newForm.receiveAddress[0];
            this.receiveAddress = resutlReAddr;
            this.applyPackInfo.receiveAddress =  this.receiveAddress;
          }
          if(newForm.transportId){
            this.selectTId(newForm.transportId)
          }
        } else {
          this.$message.error(`${res.data.message}--获取包裹详情API`);
        }

      });
      //寄件地址
      param = {
        conditionReqs: [
          {
            conditonKey: 'billPackId',
            conditonVal: this.billPackId,
          },
        ],
        number: 'big_goods_bill_detail_send_addr',
      }
      this.$API.runReport(param).then((res) => {
        if (res.data.result) {
          let results = res.data.result.datas || []
          let newForm = results[0];
          // address: "",
          //     areaCountryId: "",
          //     areaName: "",
          //     cityName: "",
          //     companyName: "",
          //     fullName: "",
          //     phone: "",
          //     postalCode: "",
          //     provinceName: "",
          //     userAddressId: "",
          //     tel: "",
          this.sendAddress.address = newForm.address;
          this.sendAddress.areaCountryId = newForm.areaCountryId;
          this.sendAddress.areaName = newForm.areaName;
          this.sendAddress.cityName = newForm.cityName;
          this.sendAddress.companyName = newForm.companyName;
          this.sendAddress.fullName = newForm.fullName;
          this.sendAddress.phone = newForm.phone;
          this.sendAddress.postalCode = newForm.postalCode;
          this.sendAddress.provinceName = newForm.provinceName;
          this.sendAddress.userAddressId = newForm.userAddressId;
          this.sendAddress.tel = newForm.tel;


        } else {
          this.$message.error(`${res.data.message}--获取包裹详情API`);
        }
      });
    },
    resetData(formName) {
      //  重置表单
      this.memberNickname = "";
      this.$refs[formName].resetFields();
      if (formName === "newForm") {
        this.newForm.itemReqs = [
          {
            serialNumber: 1, //  序号
            boxNo: "", //  箱号
            shippingMarkNo: "", //  唛头
            itemNameCode: "", //  物品名
            itemName: "", //  物品名称
            unitPrice: "", //  单价
            quantity: 1, //  数量
            intoStorageCount: 0, //  入库件数
            weight: "", //重量
            intoStorageWeight: "", //入库重量
            volume: "", //体积
            intoStorageVolume: "", //入库体积
            specs: "", //规格汇总
            itemSpecs:[
              {
                serialNumber: 1, //  序号
                packageCount: 1, //  件数
                goodsLength: "", //  长(cm)
                goodsWide: "", //  宽(cm)
                goodsHeight: "", //  高(cm)
                volume: "", //  体积
              }
            ]
          },
        ];
      }
    },

    //   -------- 编辑会员 -----------
    changeVip() {
      this.getVipList_dia();
      //  选择会员名称
      this.isDT = true;
    },
    //远程搜索(包裹预报)
    getMembers(e) {
      this.getVipList(e);
    },
    getMembersName(e) {
      console.log(e);
      this.getVipList("", e);
    },

    // 获取会员列表
    getVipList(e, n) {
      //  获取会员列表
      Api.getMemberDownList({ memberId: e || "", nickname: n || "" }).then(
          (res) => {
            if (res.data.status === "success") {
              this.huiyuanList = res.data.result.data || [];
            }
          }
      );
    },
    //远程搜索(批量导入)
    remoteMethod(e) {
      this.getVipList(e);
    },
    getVipList_dia() {
      //  获取会员列表

      Api.getMemberDownList({
        pageStart: this.pageNum,
        pageTotal: this.size,
        memberId: this.vf.memberId,
        nickname: this.vf.nickname,
      }).then((res) => {
        if (res.data.status === "success") {
          this.huiyuanList_dis = res.data.result.data || [];
          this.total = res.data.result.pageCount || 0;
        }
      });
    },

    xz(data) {
      //  会员表格选择事件
      this.newForm.memberId = data.memberId;
      this.memberNickname = data.nickname;
      this.isDT = false;
    },
    cxEdit() {
      //  查询按钮
      this.pageNum = 1;
      this.getVipList_dia();
    },
    handleSizeChange(val) {
      //  分页事件
      this.size = val;
      this.getVipList_dia();
    },
    handleCurrentChange(val) {
      //  分页事件
      this.pageNum = val;
      this.getVipList_dia();
    },

    handleClose() {
      //  会员弹出框关闭前回调事件
      //   this.resetData("vf");
    },
    k() {
      // return false
    },

    //  删除类型
    delbut(index) {
      this.newForm.itemReqs.splice(index, 1);
    },
    warehousefun(e) {
      //console.log();
    },

    addbtn(i) {
      //console.log(i);
      this.newForm.itemReqs.push({
        serialNumber: 1, //  序号
        boxNo: "", //  箱号
        shippingMarkNo: "", //  唛头
        itemNameCode: "", //  物品名
        itemName: "", //  物品名称
        unitPrice: "", //  单价
        quantity: 1, //  数量
        intoStorageCount: 0, //  入库件数
        weight: "", //重量
        intoStorageWeight: "", //入库重量
        volume: "", //体积
        intoStorageVolume: "", //入库体积
        specs: "", //规格汇总
        itemSpecs:[
          {
            serialNumber: 1, //  序号
            packageCount: 1, //  件数
            goodsLength: "", //  长(cm)
            goodsWide: "", //  宽(cm)
            goodsHeight: "", //  高(cm)
            volume: "", //  体积
          }
        ]
      });
    },

    handleClick(tab, event) {
      // //console.log(tab, event);
      // return false
    },
    //输入会员号获取会员信息
    getmember() {
      let memberId = this.addReq.memberId;
      Api.getMemberByMemberId({ memberId: memberId }).then((res) => {
        //console.log(res.data.result.data[0].nickname);
        this.memberList = res.data.result.data;
        this.membername = res.data.result.data[0].nickname;
        ////console.log(res.data.result.data[0].nickname)
      });
    },
    //弹框输入会员号获取会员信息
    getmember1() {
      let memberId = this.memberList1.memberId;
      Api.getMemberByMemberId({ memberId: memberId }).then((res) => {
        this.memberList1 = res.data.result.data;
        this.memberList1.membername = res.data.result.data[0].nickname;
        ////console.log(res.data.result.data[0].nickname)
      });
    },
    AdvancePayment() {
      if (this.addReq.loanStatus == "bu_dian_fu:loan_status=") {
        this.whether = "否";
      } else {
        this.whether = "是";
      }
    },
    //提交
    submitForm(formName) {
      let addReq = this.addReq;
      if (addReq.isPrecious) {
        addReq.isPrecious = 1;
      } else {
        addReq.isPrecious = 0;
      }
      if (addReq.loanStatus) {
        addReq.loanStatus = "dian_fu::loan_status=";
      } else {
        addReq.loanStatus = "bu_dian_fu:loan_status=";
      }
      let encryption = {
        comment: addReq.comment,
        courierNumber: addReq.courierNumber,
        expressName: addReq.expressName,
        isPrecious: addReq.isPrecious,
        itemCategoryCode: addReq.itemCategoryCode,
        itemReqs: addReq.itemReqs,
        loanStatus: addReq.loanStatus,
        memberId: addReq.memberId,
        packageId: addReq.packageId,
        storageId: addReq.storageId,
        teamCode: addReq.teamCode,
      };

      let sing = tools.getSign(encryption);
      addReq.sign = sing;
      //console.log(addReq);
      var courierNumber = addReq.courierNumber;
      Api.addPackage(addReq).then((res) => {
        //console.log(res);
        this.$message.success(res.data.message || "添加成功");
        let that = this;
        setTimeout(() => {
          that.$router.push({
            path: "/BusinessManagement/packsDetails?number=" + courierNumber,
          });
        }, 1000);
      });
    },
  },


};
</script>

<style scoped lang="scss">
.M {
  margin-bottom: 20px;
  border: 1px solid #e0e0e0;
  box-shadow: 0px 0px 4px #e0e0e0;
  padding: 20px;
  width: 99.5%;
  box-sizing: border-box;
  .M_tabel {
    /deep/ .el-input__inner:hover,
    /deep/ .el-input__inner:focus {
      border: 1px solid #f0a261 !important;
    }
    /deep/ .el-input__inner {
      text-align: center;
    }
  }
}

.formS {
  border-bottom: 1px silver solid;
  padding-bottom: 20px;
}

.tableBox {
  width: 80%;
  padding: 20px 60px;
}
.el-col-3 {
  width: 20%;
}
.member {
  width: 100%;
  padding: 10px 0;
  box-sizing: border-box;
}
.membertop {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 20px 0 0 0;
}
.memberbotton {
  color: #f00;
}
.inpustyle ::v-deep {
  .el-input__inner {
    height: 30px;
    padding: 0 40px;
  }
}
.Clipboard {
  width: 100%;
  margin: 0 auto;
  padding: 20px 0;
  box-sizing: border-box;
  .Clipboardtop {
    width: 100%;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-around;
  }
}

.myInputs {
  ::v-deep {
    .el-input__inner {
      height: 28px;
      line-height: 28px;
    }
  }
}

.radiosBox {
  padding: 0 20px;
  margin-top: 20px;
}

/deep/ .el-cascader {
  line-height: 30px !important;
}

.topBtn {
  margin-top: 10px;
}

.mainBox {
  height: calc(100vh - 135px);
  overflow-y: auto;
}

.displayFlex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.newForm .queryItem1 {
  margin-bottom: 14px;
}
.wtl_displayFlex {
  display: flex;
  align-items: center;
}
.wtl_displayFlex2 {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.ItemServerBox {
  margin-top: 10px;
  margin-right: 30px;
}
// .serverItems {
//   margin-top: 10px;
//   margin-right: 10px;
// }
.totBtns {
  background-color: #fff;
  margin-left: 4px;
  font-size: 12px;
  background-color: #409eff;
  color: #fff;
  padding: 4px;
  border-radius: 2px;
}
.countInput {
  border: 1px solid #d7d7d7;
  border-radius: 4px;
  width: 60px;
}
.labelNum {
  width: 40px;
}

// 去掉数字输入框上下箭头
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
::v-deep input[type="‘number’"] {
  -moz-appearance: textfield !important;
}

.topbox {
  margin-top: 20px;

  ::v-deep {
    .el-checkbox-group {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    .el-checkbox {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      min-width: 25%;
      width: 300px;
    }

    .el-checkbox__label {
      flex: 1;
      display: flex;
      align-items: center;
      //  justify-content: space-between;
    }
  }
}

.highlight-row {
  background-color: #f0c786 !important; // 聚焦背景色（如橙色）
}
.rowflexbox{
  display: flex;
  align-items: center;
  gap: 8px; // 设置按钮之间的间距
}
</style>
